<template>
  <div>
    <Modal class="group-modal" :value="visible" title="添加包组" @on-visible-change="visibleChange" width="850px" :transfer="status==='normal'">
      <div class="title">包组基本信息：</div>
      <div style="margin:5px;display:flex">
        <span style="flex:1">项目预算：{{projectData.purchaseBudget}}元</span>
        <span style="flex:1">服务费类型：{{projectData.serviceFeeType}}</span>
        <span style="flex:1" v-if="projectData.serviceFeeType == '折扣'">
          折扣率：{{projectData.discount}}%
        </span>
        <span style="flex:1" v-else>
          定额服务费：{{projectData.servicePredict}}元
        </span>
      </div>
      <div>
        <Form ref="groupForm" :model="groupForm" :rules="groupRules" inline :label-width="100">
          <FormItem prop="num" label="包组序号">
            <Input type="text" v-model="groupForm.num" readonly style="width:100px;"></Input>
          </FormItem>
          <FormItem prop="groupName" label="包组名称">
            <Input type="text" v-model="groupForm.groupName" style="width: 350px;"></Input>
          </FormItem>
          <FormItem prop="budget" label="包组采购预算">
            <Input type="text" v-model="groupForm.budget"></Input>
          </FormItem>
          <FormItem prop="priceSection" label="价格段">
            <Input type="text" v-model="groupForm.priceSection"></Input>
          </FormItem>
          <FormItem prop="groupType" label="采购类别">
            <Select v-model="groupForm.groupType" style="width:100px;">
              <Option v-for="item in groupTypeArr" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </FormItem>
          <!-- <FormItem prop="deals" label="包组交易情况">
            <Select v-model="groupForm.deals" style="width:100px;" clearable>
              <Option value="成功"></Option>
              <Option value="失败"></Option>
            </Select>
          </FormItem> -->
          <FormItem prop="serviceType" label="服务费类型">
            <Input type="text" v-model="groupForm.serviceType" readonly style="width:100px;margin-right:10px;"></Input>
            <Button type="primary" size="small" @click="selectFeeType">选择</Button>
          </FormItem>
          <!-- <FormItem prop="discount" label="折扣值">
            <Input type="text" v-model="groupForm.discount" readonly style="width:100px;"></Input>%
          </FormItem>
          <FormItem prop="requirement" label="定额值">
            <Input type="text" v-model="groupForm.requirement" readonly></Input>
          </FormItem> -->
          <FormItem prop="receivables" label="包组应收款预算" style="margin-left:13px;">
            <Input type="text" v-model="groupForm.receivablesPredict" readonly style="width:100px;margin-right:10px;"></Input>
            <!-- <Button type="primary" size="small" @click="selectFeeType">选择</Button> -->
          </FormItem>
          <FormItem prop="receivables" label="包组应收款">
            <Input type="text" v-model="groupForm.receivables" readonly style="width:100px;margin-right:10px;"></Input>
            <!-- <Button type="primary" size="small" @click="selectFeeType">选择</Button> -->
          </FormItem>
          <FormItem prop="depositAmount" label="应收保证金">
            <Input type="text" v-model="groupForm.depositAmount" style="width:100px;margin-right:10px;"></Input>
            <!-- <Button type="primary" size="small" @click="selectFeeType">选择</Button> -->
          </FormItem>
          <FormItem label="采购人付款">
            <Select v-model="groupForm.isBuyer" style="width:80px;">
              <Option value="是">是</Option>
              <Option value="否">否</Option>
            </Select>
          </FormItem>
        </Form>
      </div>
      <div slot="footer">
        <Button @click="cancel">取消</Button>
        <Button @click="submitGroup" type="primary" :disabled="editPermission">确定</Button>
      </div>
    </Modal>
    <Modal v-model="feeGetVisible" title="服务费类型" :transfer="which && status === 'normal'">
      <RadioGroup v-model="feeType" style="margin-right:30px;">
        <Radio label="折扣"></Radio>
        <Radio label="定额"></Radio>
      </RadioGroup>
      <div style="display:inline-block" v-show="feeType==='折扣'">
        <span>折扣率：</span>
        <Input v-model="feeDiscount" type="text" style="width:80px;"></Input>
        <span>%</span>
      </div>
      <div style="display:inline-block" v-show="feeType==='定额'">
        <span>类型：</span>
        <Select style="width:100px;" v-model="quotaType">
          <Option value="项目定额">项目定额</Option>
          <Option value="中标人定额">中标人定额</Option>
        </Select>
        <span style="margin-left:10px;">服务费：</span>
        <Input type="text" v-model="quota" style="width:100px;"></Input>
      </div>
      <div slot="footer">
        <Button @click="feeGetVisible=false">取消</Button>
        <Button type="primary" @click="setFee">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import ajax from '@/lib/ajax'
import requestUrls from '@/lib/requestUrls'
import { getFee } from '@/lib/serviceFee'

export default {
  name: 'group',
  props: {
    status: {
      type: String,
      default: 'normal'
    },
    projectData: {
      type: Object,
    },
    visible: {
      type: Boolean,
      default: false
    },
    insertIndex: {},
    editGroup: {
      default: '',
    },
    editPermission: {
      default: false
    },
    which:{
      default: true
    }
  },
  data() {
    let validNum = (rule, value, callback) => {
      if (isNaN(value) || value === "" || value === null) {
        callback(new Error("请输入数字"));
      } else {
        callback();
      }
    }
    return {
      groupForm: {
        id: '',
        num: '',
        budget: '',
        priceSection: '',
        deals: '',
        groupName: '',
        serviceType: '',
        discount: '',
        requirement: '',
        groupType: '',
        receivables: '',
        receivablesPredict: '',
        depositAmount: '',
        isBuyer: '否'
      },
      groupRules: {
        budget: [
          { required: true, message: '不能为空', trigger: 'blur' },
          { validator: validNum, trigger: "blur" }
        ],
        groupName: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        serviceType: [
          { required: true, message: '不能为空', trigger: 'change' }
        ],
        groupType: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        // receivables: [
        //   { required: true, message: '不能为空', trigger: 'blur' }
        // ],
        depositAmount: [
          { required: true, message: '不能为空', trigger: 'blur'},
          { validator: validNum, trigger: "blur" }
        ],
      },
      groupTypeArr: [
        {
          label: '货物',
          value: '货物'
        },
        {
          label: '服务',
          value: '服务'
        },
        {
          label: '工程',
          value: '工程'
        },
      ],
      feeGetVisible: false,
      feeType: '折扣',
      feeDiscount: '',
      quotaType: '',
      quota: ''
    }
  },
  methods: {
    cancel() {
      this.$emit('cancel')
    },
    submitGroup() {
      this.$refs.groupForm.validate(async valid => {
        if (valid) {
          this.$Spin.show()
          try {
            let isBuyer = false
            if (this.groupForm.isBuyer === '是') {
              isBuyer = true
            }
            let rep = await ajax.post(requestUrls.ClGroupDb.CreateOrUpdate, {
              "clGroupDb": {
                "id": this.groupForm.id,
                "groupNo": this.groupForm.num,
                "projectId": this.projectData.id,
                "groupName": this.groupForm.groupName,
                "groupDudget": this.groupForm.budget,
                "priceTier": this.groupForm.priceSection,
                "groupStatus": this.groupForm.deals,
                "serviceCharge": this.groupForm.serviceType,
                "discount": this.groupForm.discount,
                "quota": this.groupForm.requirement,
                "purchaseType": this.groupForm.groupType,
                "groupReceivable": this.groupForm.receivables,
                "groupReceivablePredict": this.groupForm.receivablesPredict,
                "marginAmount": this.groupForm.depositAmount,
                "isBuyer": isBuyer
              }
            })
            this.$Spin.hide()
            if (rep.data.success) {
              this.$Message.success('添加包组成功')
              this.$emit('editSuccess')
            } else {
              this.$Message.error('添加包组失败')
            }
          } catch (err) {
            console.error(err)
            this.$Spin.hide()
            this.$Message.error('添加包组失败')
          }
        }
      })
    },
    visibleChange(val) {
      if (!val) {
        this.$emit('cancel')
      }
    },
    selectFeeType() {
      // 检查填写状态
      if (this.groupForm.budget === '') {
        this.$Message.error('请输入采购预算')
        return
      }
      if (this.groupForm.groupType === '') {
        this.$Message.error('请输入采购类别')
        return
      }
      this.feeGetVisible = true
    },
    setFee() {
      if (this.feeType === '折扣') {
        if (this.feeDiscount === '') {
          this.$Message.error('折扣率不能为空')
          return
        }
        let feeDiscount = parseFloat(this.feeDiscount)
        if (isNaN(feeDiscount) || feeDiscount < 0) {
          this.$Message.error('折扣率大于0')
          return
        }
        this.groupForm.requirement = ''
        this.groupForm.serviceType = this.feeType
        this.groupForm.discount = feeDiscount
        this.groupForm.receivablesPredict = getFee(this.groupForm.budget, feeDiscount, this.groupForm.groupType)
        this.feeGetVisible = false
      }
      if (this.feeType === '定额') {
        if (this.quotaType === '') {
          this.$Message.error('定额类型不能为空')
          return
        }
        if (this.quota === '') {
          this.$Message.error('服务费不能为空')
          return
        }
        let quota = parseFloat(this.quota)
        if (isNaN(quota) || this.quota < 0) {
          this.$Message.error('服务费为非数字或小于0')
          return
        }
        this.groupForm.discount = ''
        this.groupForm.serviceType = this.quotaType
        this.groupForm.requirement = this.quota
        this.groupForm.receivablesPredict = this.quota
        this.feeGetVisible = false
      }
      // 清空数据
      this.quota = ''
      this.quotaType = ''
      this.feeType = ''
      this.feeDiscount = ''
    }
  },
  watch: {
    insertIndex(val) {
      if (val) {
        this.groupForm.num = val
      }
    },
    editGroup(val) {
      if (val) {
        this.groupForm.id = val.id
        this.groupForm.num = val.groupNo
        this.groupForm.groupName = val.groupName
        this.groupForm.budget = ''
        if (val.groupDudget) {
          this.groupForm.budget = val.groupDudget.toString()
        }
        this.groupForm.priceSection = val.priceTier
        this.groupForm.deals = val.groupStatus
        this.groupForm.serviceType = val.serviceCharge
        this.groupForm.depositAmount = ''
        if (val.marginAmount) {
          this.groupForm.depositAmount = val.marginAmount.toString()
        }
        // 服务费类型
        if (val.serviceCharge.indexOf('定额') !== -1) {
          this.feeType = '定额'
          this.quotaType = val.serviceCharge
        } else if (val.serviceCharge === '折扣') {
          this.feeType = '折扣'
        }
        this.groupForm.discount = val.discount
        this.feeDiscount = val.discount
        this.groupForm.requirement = val.quota
        this.quota = val.quota
        this.groupForm.groupType = val.purchaseType
        this.groupForm.receivables = ''
        if (val.groupReceivable) {
          this.groupForm.receivables = val.groupReceivable.toString()
        }
        if (val.groupReceivablePredict) {
          this.groupForm.receivablesPredict = val.groupReceivablePredict.toString()
        }
        this.groupForm.isBuyer = '否'
        if (val.isBuyer) {
          this.groupForm.isBuyer = '是'
        }
      } else {
        // 清空数据
        this.groupForm.id = ''
        this.groupForm.num = this.insertIndex // 包组序号使用插入的序号
        this.groupForm.groupName = ''
        this.groupForm.budget = ''
        this.groupForm.priceSection = ''
        this.groupForm.deals = ''
        this.groupForm.serviceType = ''
        this.groupForm.discount = ''
        this.groupForm.requirement = ''
        this.groupForm.groupType = ''
        this.groupForm.receivables = ''
        this.groupForm.depositAmount = ''
        this.groupForm.isBuyer = '否'
        this.groupForm.receivablesPredict = ''
      }
    },
    // 'groupForm.budget'(){
    //   this.groupForm.serviceType = ''
    //   this.groupForm.discount = ''
    //   this.groupForm.requirement = ''
    // },
    // 'groupForm.groupType'(){
    //   this.groupForm.serviceType = ''
    //   this.groupForm.discount = ''
    //   this.groupForm.requirement = ''
    // }
  }
}
</script>

<style lang="less">
.group-modal {
  .title {
    font-weight: 600;
  }
}
</style>
